import { render, staticRenderFns } from "./FreezingTotalList.vue?vue&type=template&id=9a98f7b2&scoped=true&"
import script from "./FreezingTotalList.vue?vue&type=script&lang=js&"
export * from "./FreezingTotalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a98f7b2",
  null
  
)

export default component.exports